module.exports = __webpack_public_path__ + "img/group2.a58b4830.png";